import axios from "axios";
import baseURL from "./../api";
class AgentsService {
    constructor() {
        this.time = new Date().getTime();
    }
    getAgents() {
        return axios.get(`${baseURL}/agent?${this.time}`);
    }
    addAgent(data) {
        return axios.post(`${baseURL}/agent/create?${this.time}`,data);

    }
    approveAgentAction(data) {
        return axios.post(`${baseURL}/agent/approve?${this.time}`,data);
    }
    getAgentDetails(id) {
        return axios.get(`${baseURL}/agent/${id}?${this.time}`);
    }
    suspendAgent(data) {
        return axios.post(`${baseURL}/agent/suspend?${this.time}`,data);
    }
    resumeAgent(data) {
        return axios.post(`${baseURL}/agent/resume?${this.time}`,data);
    }
    deleteAgentData(id) {
        return axios.delete(`${baseURL}/agent/${id}?${this.time}`);
    }
    updateAgentProfile(id, data) {
        return axios.patch(`${baseURL}/user/${id}?${this.time}`,data);
    }
}
export default new AgentsService();